var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.875,
    height: 47.451,
    viewBox: "0 0 48.875 47.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(-5.717 -11.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M64.6-455.969l-2.71-2.178c-1.8-1.691-5.8-3.827-10.326-5.519l-2.243-.855-1.247,1.05a14.046,14.046,0,0,1-4.54,2.706,8.111,8.111,0,0,1-3.525.463,8.111,8.111,0,0,1-3.525-.463,14.056,14.056,0,0,1-4.54-2.706L30.7-464.52l-2.243.855c-4.522,1.691-8.528,3.827-10.345,5.536l-2.384,2.16s6.109,13.635,24.284,13.635S62.746-453.217,64.6-455.969Z",
    transform: "translate(-10.01 501.074)",
    fill: "#2D3040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M315.866-329.973a12.313,12.313,0,0,0-5.358,2.85c-4.564,4.221-5.394,10.679-2.237,17.119,3.121,6.368,8.677,9.272,13.494,7.072,3.77-1.714,6.981-6.043,8.208-11.076a16.171,16.171,0,0,0,.072-6.765C328.3-327.376,322.2-331.344,315.866-329.973Z",
    transform: "translate(-288.389 341.531)",
    fill: "#2D3040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSolid);
export default __webpack_public_path__ + "static/media/account-solid.f55845d3620f78e3c58d394d22fcbb6a.svg";
export { ForwardRef as ReactComponent };